import DialogueManageDetailComponent from './component';

class DialogueManageDetailRoute extends DialogueManageDetailComponent {

}

export default DialogueManageDetailRoute;
